<template>
  <div>
    <div class="checkbox-wrapper modal-register-conditions">
      <div class="checkbox">
        <input name="согласие" type="checkbox" v-model="model" id="register-conditions"/>
        <!-- Дополнительные условия формы (например, регламент олимпиады) - в слоте перед общими -->
        <label for="register-conditions"><slot></slot>Я согласен(на) с условиями <a target="_blank" href="https://exporteduru.servicecdn.ru/media/default/0003/48/6466dc3ff5044fe7c404fd9d0f7cffaf5757ab1e.pdf">пользовательского соглашения</a> и
          <a target="_blank" href="https://exporteduru.servicecdn.ru/media/default/0003/49/adebe167c826cdcf243eb02978c5f125b65c0a88.pdf">политикой обработки персональных данных</a></label>
      </div>
    </div>
  </div>
</template>

<script>
import vmMixin from "@/mixins/vmMixin";

export default {
  name: "RegistrationFormCondition",
  mixins: [vmMixin],
  data() {
    return {
      newsletterModel: true
    }
  },
  watch: {
    newsletterModel: {
      handler: function(val) {
        this.$emit('newsletter-change', val)
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>